export default __webpack_public_path__ + "static/swivel-e1c3f37d879bc8a1946f92603ad4e24d.png";